import React from "react";
import SideBar from "../../layouts/sidebar/SideBar.tsx";
import Leo from "./../../../assets/icons/user.png";
import "./AdminDashboard.css";
import resImg from "./../../../assets/icons/restaurantBlack.png";
import reportImg from "./../../../assets/icons/statistics.png";
import homeImg from "./../../../assets/icons/landing-page.png";
import manageImg from "./../../../assets/icons/management.png";
import kycImg from "./../../../assets/icons/kyc.png";
import courierImg from "./../../../assets/icons/courier.png";
import { useNavigate } from "react-router-dom";
import jwt_decode from "jwt-decode";
import TopHeader from "../../../components/TopHeader.tsx";
import communication from "../../../assets/images/message.png";
function AdminDashboard(props) {
  const navigate = useNavigate();
  const [tokenData, setTokenData] = React.useState({
    UserName: "",
    UserImg: "",
  });
  React.useEffect(() => {
    const token = localStorage.getItem("gotasteadmintoken");
    var decodedData = {};
    if (token != null) {
      try {
        decodedData = jwt_decode(token);
        console.log(decodedData);
        setTokenData(decodedData);
      } catch (error) {}
    }
  }, []);
  return (
    <div>
      <TopHeader />
      <div className="row">
        <div className="col-md-6 col-lg-4 col-xl-3">
          <div
            className="wrimagecard wrimagecard-topimage"
            onClick={() => {
              navigate("/restaurant-request");
            }}
          >
            <div className="wrimagecard-topimage_header">
              <img src={resImg} alt="" className="img-circle" />
            </div>
            <div className="wrimagecard-topimage_title h-140">
              <h2 style={{ fontWeight: "100 !important", fontSize: "1.5rem" }}>
                New Restaurant Request
              </h2>
              <p>Manage New Restaurant Request and many more..</p>
            </div>
            <div className="rounded-CircleIcon">1</div>
            <div className="card-action-bar">
              <a className="float-lg-none link">View Requests</a>
            </div>
          </div>
        </div>
        <div className="col-md-6 col-lg-4 col-xl-3">
          <div
            className="wrimagecard wrimagecard-topimage"
            onClick={() => {
              navigate("/kyc-requests");
            }}
          >
            <div className="wrimagecard-topimage_header">
              <img src={kycImg} alt="" className="img-circle" />
            </div>
            <div className="wrimagecard-topimage_title h-140">
              <h2 style={{ fontWeight: "100 !important", fontSize: "1.5rem" }}>
                KYC Verification Request
              </h2>
              <p>View KYC Verification request and many more..</p>
            </div>
            <div className="card-action-bar">
              <a className="float-lg-none link">
                View KYC Verification Requests
              </a>
            </div>
          </div>
        </div>
        <div className="col-md-6 col-lg-4 col-xl-3">
          <div
            className="wrimagecard wrimagecard-topimage"
            onClick={() => {
              navigate("/courier-requests");
            }}
          >
            <div className="wrimagecard-topimage_header">
              <img src={courierImg} alt="" className="img-circle" />
            </div>
            <div className="wrimagecard-topimage_title h-140">
              <h2 style={{ fontWeight: "100 !important", fontSize: "1.5rem" }}>
                Courier Request
              </h2>
              <p>Manage Manage Courier Request and many more..</p>
            </div>
            <div className="card-action-bar">
              <a className="float-lg-none link">View Restaurant</a>
            </div>
          </div>
        </div>
        <div className="col-md-6 col-lg-4 col-xl-3">
          <div
            className="wrimagecard wrimagecard-topimage"
            onClick={() => {
              navigate("/manage-restaurant-admin");
            }}
          >
            <div className="wrimagecard-topimage_header">
              <img src={manageImg} alt="" className="img-circle" />
            </div>
            <div className="wrimagecard-topimage_title h-140">
              <h2 style={{ fontWeight: "100 !important", fontSize: "1.5rem" }}>
                Manage Restaurant
              </h2>
              <p>Manage Manage Restaurant and many more..</p>
            </div>
            <div className="card-action-bar">
              <a className="float-lg-none link">View Restaurant</a>
            </div>
          </div>
        </div>

        <div className="col-md-6 col-lg-4 col-xl-3">
          <div
            className="wrimagecard wrimagecard-topimage"
            onClick={() => {
              navigate("/manage-deliveryman-admin");
            }}
          >
            <div className="wrimagecard-topimage_header">
              <img src={manageImg} alt="" className="img-circle" />
            </div>
            <div className="wrimagecard-topimage_title h-140">
              <h2 style={{ fontWeight: "100 !important", fontSize: "1.5rem" }}>
                Manage Delivery Man
              </h2>
              <p>Manage Manage Delivery Man and many more..</p>
            </div>
            <div className="card-action-bar">
              <a className="float-lg-none link">View Delivery Man</a>
            </div>
          </div>
        </div>
        <div className="col-md-6 col-lg-4 col-xl-3">
          <div
            className="wrimagecard wrimagecard-topimage"
            onClick={() => {
              navigate("/admin-settings");
            }}
          >
            <div className="wrimagecard-topimage_header">
              <img src={homeImg} alt="" className="img-circle" />
            </div>
            <div className="wrimagecard-topimage_title h-140">
              <h2 style={{ fontWeight: "100 !important", fontSize: "1.5rem" }}>
                Manage Home Page
              </h2>
              <p>Manage Home Page and many more..</p>
            </div>
            <div className="card-action-bar">
              <a className="float-lg-none link">View Home Page Sections</a>
            </div>
          </div>
        </div>

        {/* Manage Credits Card */}
        {/* <div className="col-md-6 col-lg-4 col-xl-3" style={{ cursor: 'pointer' }}>
          <div
            className="wrimagecard wrimagecard-topimage"
            onClick={() => {
              navigate("/manage-credits");
            }}
          >
            <div className="wrimagecard-topimage_header">
              <img src={homeImg} alt="" className="img-circle" />
            </div>
            <div className="wrimagecard-topimage_title h-140">
              <h2 style={{ fontWeight: "100 !important", fontSize: "1.5rem" }}>
                Manage Credit
              </h2>
              <p>Manage Credit and more..</p>
            </div>
            <div className="card-action-bar">
              <a className="float-lg-none link">View Manage-Credits Sections</a>
            </div>
          </div>
        </div> */}

        <div className="col-md-6 col-lg-4 col-xl-3">
          <div className="wrimagecard wrimagecard-topimage">
            <div className="wrimagecard-topimage_header">
              <img src={reportImg} alt="" className="img-circle" />
            </div>
            <div className="wrimagecard-topimage_title h-140">
              <h2 style={{ fontWeight: "100 !important", fontSize: "1.5rem" }}>
                Reports
              </h2>
              <p>View Reports and many more..</p>
            </div>
            <div className="card-action-bar">
              <a className="float-lg-none link">View Reports</a>
            </div>
          </div>
        </div>
        <div className="col-md-6 col-lg-4 col-xl-3">
          <div className="wrimagecard wrimagecard-topimage">
            <div className="wrimagecard-topimage_header">
              <div className="iconPosition" style={{ top: "-18%" }}>
                <div className="circle">
                  <img
                    src={communication}
                    alt="icon"
                    style={{ width: "3rem", height: "3rem" }}
                  />
                </div>
              </div>
            </div>
            <div
              className="wrimagecard-topimage_title h-140"
              onClick={() => {
                navigate("/admin-communication");
              }}
            >
              <h2 style={{ fontWeight: "100 !important", fontSize: "1.5rem" }}>
                Admin Communication
              </h2>
              <p>Manage , and view communication here</p>
            </div>

            <div className="card-action-bar">
              <a className="float-lg-none link">Make communication</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdminDashboard;
